"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundMicrosToNearestDollar = void 0;
const roundMicrosToNearestDollar = (micros) => {
    if (micros) {
        return Math.ceil(micros * 100) / 100;
    }
    return null;
};
exports.roundMicrosToNearestDollar = roundMicrosToNearestDollar;
//# sourceMappingURL=helpers.js.map